import DocumentPage from "../../../invoice/DocumentPage";
import { purchaseOrderConfig } from "./config";

const PurchaseOrder = () => <DocumentPage config={purchaseOrderConfig} />;

export default PurchaseOrder;
